import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import api, { humanizeAxiosError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd1, setPwd1] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd1.length < 6) return toast.error("Şifre en az 6 karakter olmalı");
    if (pwd1 !== pwd2) return toast.error("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd1 });
      toast.success("Şifreniz güncellendi. Giriş yapabilirsiniz.");
      nav("/login");
    } catch (e) {
      toast.error(humanizeAxiosError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 space-y-6">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Colossae Personel</div>
            <h1 className="font-display text-3xl font-bold mt-1">Yeni Şifre Belirle</h1>
            <div className="text-sm text-muted-foreground mt-1">Yeni şifrenizi 2 kez giriniz.</div>
          </div>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label>Yeni Şifre</Label>
              <div className="relative">
                <Input type={show ? "text" : "password"} required minLength={6} value={pwd1} onChange={(e) => setPwd1(e.target.value)} className="pr-10" data-testid="rp-pwd1" />
                <button type="button" onClick={() => setShow((v) => !v)} className="absolute inset-y-0 right-2 flex items-center text-muted-foreground" data-testid="rp-toggle">
                  {show ? <EyeSlash size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <div>
              <Label>Yeni Şifre (Tekrar)</Label>
              <Input type={show ? "text" : "password"} required minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="rp-pwd2" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="rp-submit">
              {loading ? "Güncelleniyor…" : "Şifreyi Güncelle"}
            </Button>
          </form>

          <Link to="/login" className="text-sm text-primary underline block text-center">Girişe dön</Link>
        </CardContent>
      </Card>
    </div>
  );
}
